module.exports = __webpack_public_path__ + "static/media/2.4fb84667.mp4";